import type { ISaveDraftResponse } from '@/types/services/draft.service';
import type { IMessageResponse } from '@/types/services/message.service';
import type { EventBusKey } from '@vueuse/core';

export const openAdvancedSearchEventKey: EventBusKey<void> = Symbol('openAdvancedSearch');

export const THREAD_LIST_DRAFT_SAVED_EVENT_KEY: EventBusKey<{
  response: ISaveDraftResponse;
  threadId: ISaveDraftResponse['threadId'] | null;
  baseMessageId?: IMessageResponse['messageId'];
}> = Symbol('threadListDraftSaved');
